// extracted by mini-css-extract-plugin
module.exports = {"icon_active":"DefaultButton_icon_active__qtXl0"};